import { QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseManager } from 'ag-grid-enterprise';
import { SessionProvider } from './contexts';
import { AuthProvider } from './contexts/AuthContext';
import { queryClient } from './lib/queryClient';
import './index.css';
import App from './App';

const licenseKey = import.meta.env.VITE_AG_GRID_KEY || import.meta.env.AG_GRID_KEY;
if (licenseKey) {
  LicenseManager.setLicenseKey(licenseKey);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </AuthProvider>
      </QueryClientProvider>
    </MantineProvider>
  </React.StrictMode>
);
